import { getList } from '@/dataProvider/pspDataProvider/getList';
import { getItem } from '@/dataProvider/pspDataProvider/getItem';

export const pspDataProvider = {
  getList,
  getItem,
};
